/* ==========================================================================
   ORW Footer -- Accordion behavior for link columns

   The Liquid renders <details open> so desktop (>= 990px) shows all link
   columns expanded immediately (no flash-of-closed-state on first paint).
   On mobile/tablet (< 990px) this script removes the [open] attribute so
   each column starts collapsed. The native <details>/<summary> handles
   the tap-to-toggle behavior from there.
   ========================================================================== */

(function () {
  'use strict';

  var mql = window.matchMedia('(min-width: 990px)');

  function updateAccordions() {
    var isDesktop = mql.matches;
    var items = document.querySelectorAll('[data-orw-footer-accordion]');
    for (var i = 0; i < items.length; i++) {
      if (isDesktop) {
        items[i].setAttribute('open', '');
      } else {
        items[i].removeAttribute('open');
      }
    }
  }

  // Run as early as possible to avoid flash-of-open-state on mobile.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAccordions);
  } else {
    updateAccordions();
  }

  // Re-evaluate when the viewport crosses the breakpoint (e.g. rotation).
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', updateAccordions);
  } else if (typeof mql.addListener === 'function') {
    // Safari < 14 fallback
    mql.addListener(updateAccordions);
  }
})();
